/**
 * 左填充
 *
 * @param num 数字
 * @param l 长度，默认2
 * @param str 填充字符，默认0
 * @returns {string}
 */
export const padLeft = (num, l = 2, str = '0') => {
  num += ''; // 转字符
  const len = l - num.length;
  if (len > 0) {
    if (l === 2) {
      num = `${str}${num}`;
    } else {
      for (let i = 0; i < len; i++) {
        num = `${str}${num}`;
      }
    }
  }
  return num;
};

/**
 * 格式化时间戳
 *
 * @param timestamps 时间戳
 * @returns {String}
 */
export const formatTimeFromTimestamps = (timestamps = '') => {
  if (!timestamps) return 0;
  try {
    let date = new Date(timestamps).getTime();
    return date;
  } catch (err) {
    console.log('formatTimeFromTimestamps ==> ', err);
    return 0;
  }
};

// 获取链接的数组
export const getUrlParams = search => {
  search = search || location.search;
  var paramsSplit = search.replace(/^[^\?]*\?/i, '').split('&');
  var params = {};

  if (Array.isArray(paramsSplit)) {
    paramsSplit.forEach(function(item) {
      const itemSplit = item.split('=');
      params[itemSplit[0]] = itemSplit[1];
    });
  }
  return params;
};




// WEBPACK FOOTER //
// ./src/utils/util.js